import { useCallback } from 'react';
import { useClient } from './use-client';

function useStaticResolver() {
  var client = useClient();
  return useCallback(function (assetPath) {
    if (assetPath != null) {
      return client.getStaticAssetUrl(assetPath);
    } else {
      throw Error("unsupported or empty asset path: " + assetPath);
    }
  }, [client]);
}

export { useStaticResolver };
//# sourceMappingURL=use-static-resolver.js.map